import styled from 'styled-components'
import { UniversalPortal } from '@jesstelford/react-portal-universal'
import Overlay from 'common/Overlay'

const AsideMenuStyled = styled.div`
  color: var(--white);
  .aside-menu {
    display: flex;
    justify-content: flex-end;
    inline-size: 100vw;
  }
  .aside-menu-container {
    padding: 1.5rem;
    background: var(--neutral100);
    height: 100vh;
    flex: 1;
  }
  @media (min-width: 1024px) {
    .aside-menu-container {
      inline-size: 466px;
      max-inline-size: 466px;
      block-sizing: border-box;
    }
  }
`

function AsideMenu({ children, show }) {
  return (
    <UniversalPortal selector="#page-portal">
      {show ? (
        <AsideMenuStyled>
          <Overlay zIndex={10} isActive background="#04001eb3">
            <div className="aside-menu">
              <div className="aside-menu-container">
                {children}
              </div>
            </div>
          </Overlay>
        </AsideMenuStyled>
      ) : null}
    </UniversalPortal>

  )
}

export default AsideMenu
